import React, { useMemo, useState } from 'react';

import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  MenuProps,
} from 'antd';

import { FluxStatusDtoStatusEnum } from 'lib_api/lib/api/gen';

import { FluxDisplayName } from 'enums/flux/FluxDisplayName';
import { FluxRoutes } from 'enums/flux/FluxRoutes';
import { fluxTypeFromFluxStatusDto } from 'enums/flux/FluxType';
import { useAdminFluxStatuses } from 'hooks/flux/useAdminFluxStatuses';
import { profileEnumMapping } from 'utils/enumData';

import { FluxStatus } from './FluxStatus';
import { FluxStatusIcon } from './FluxStatusIcon';

import './FluxStatuses.less';

const FluxStatuses: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const adminRootPath = profileEnumMapping['ADMIN_FONCTIONNEL'].homePath;

  const statuses = useAdminFluxStatuses().data?.statuses ?? [];

  const menuStatuses: MenuProps = {
    items: statuses
      .sort((s1, s2) => s1.flux.localeCompare(s2.flux))
      .map((s, i) => {
        const resolvedType = fluxTypeFromFluxStatusDto(s.flux);
        return {
          key: i,
          label: (
            <FluxStatus
              title={FluxDisplayName[resolvedType]}
              status={s.status}
              url={`${adminRootPath}${FluxRoutes[resolvedType]}`}
            />
          ),
        };
      }),
  };

  const worseFluxStatus = useMemo(() => {
    if (statuses.some(s => s.status === FluxStatusDtoStatusEnum.ERROR)) {
      return FluxStatusDtoStatusEnum.ERROR;
    }
    if (statuses.some(s => s.status === FluxStatusDtoStatusEnum.WARNING)) {
      return FluxStatusDtoStatusEnum.WARNING;
    }
    if (statuses.some(s => s.status === FluxStatusDtoStatusEnum.SUCCESS)) {
      return FluxStatusDtoStatusEnum.SUCCESS;
    }
    return undefined;
  }, [statuses]);

  return (
    <div className="notification-container">
      <AntdDropdown
        menu={menuStatuses}
        open={menuOpen}
        onOpenChange={setMenuOpen}
      >
        <AntdButton
          type="default"
          shape="round"
          size="middle"
          aria-label={`Menu des flux - Statut global: ${
            worseFluxStatus ?? 'Aucun flux'
          }`}
          aria-haspopup="menu"
          aria-expanded={menuOpen}
        >
          {'Flux'}
          {worseFluxStatus && (
            <div className={'icon'} aria-hidden={true}>
              <FluxStatusIcon status={worseFluxStatus} />
            </div>
          )}
        </AntdButton>
      </AntdDropdown>
    </div>
  );
};

export default FluxStatuses;
